import React from "react";
import PersonList from "../../Person/PersonList";

const Persons = () => {
  return (
    <>
      <div className={"mb-2"}>
        <PersonList excludePersonList={[]} />
      </div>
    </>
  );
};

export default Persons;
